import React from 'react';
import { Box, Button } from '@mui/material';
import { PDFDownloadLink } from '@react-pdf/renderer';
import InvoicePDF from './InvoicePDF';
import PrintIcon from '@mui/icons-material/Print';

const ActionButtons = ({ 
  setSearchOpen, 
  setCustomPartOpen, 
  setUnitByWeightOpen, 
  currentInvoice,
  formData,
  invoiceStats,
  aggregateParts,
  showFullPartNumbers,
  onAddEmptyPart,
  onAddAftermarketPart
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-around', marginBottom: '20px', gap: 2 }}>
      <Button
        onClick={() => setSearchOpen(true)}
        sx={{
          backgroundColor: '#24e4ff',
          color: '#000',
          borderRadius: '30px',
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#35d33d',
          },
        }}
      >
        Add Part
      </Button>
      <Button
        onClick={() => setCustomPartOpen(true)}
        sx={{
          backgroundColor: '#24e4ff',
          color: '#000',
          borderRadius: '30px',
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#35d33d',
          },
        }}
      >
        Custom Part
      </Button>
      <Button
        onClick={() => setUnitByWeightOpen(true)}
        sx={{
          backgroundColor: '#24e4ff',
          color: '#000',
          borderRadius: '30px',
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#35d33d',
          },
        }}
      >
        Unit By Weight
      </Button>
      <Button
        onClick={onAddEmptyPart}
        sx={{
          backgroundColor: '#24e4ff',
          color: '#000',
          borderRadius: '30px',
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#35d33d',
          },
        }}
      >
        Add an Empty
      </Button>
      <Button
        onClick={onAddAftermarketPart}
        sx={{
          backgroundColor: '#24e4ff',
          color: '#000',
          borderRadius: '30px',
          padding: '15px 30px',
          fontSize: '16px',
          fontWeight: 'bold',
          '&:hover': {
            backgroundColor: '#35d33d',
          },
        }}
      >
        Add Aftermarket
      </Button>
      {currentInvoice && (
        <PDFDownloadLink
          document={
            <InvoicePDF 
              invoice={{
                ...currentInvoice,
                customerName: formData.customerName,
                companyName: formData.companyName,
                priceList: formData.priceList,
                parts: {
                  items: currentInvoice.parts?.items || []
                }
              }}
              stats={invoiceStats}
              aggregateParts={aggregateParts}
              showFullPartNumbers={showFullPartNumbers}
            />
          }
          fileName={`invoice-${currentInvoice.invoiceNumber || 'draft'}.pdf`}
        >
          {({ blob, url, loading, error }) => (
            <Button
              disabled={loading}
              startIcon={<PrintIcon />}
              sx={{
                backgroundColor: '#24e4ff',
                color: '#000',
                borderRadius: '30px',
                padding: '15px 30px',
                fontSize: '16px',
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#35d33d',
                },
              }}
            >
              {loading ? 'Generating PDF...' : 'Print Invoice'}
            </Button>
          )}
        </PDFDownloadLink>
      )}
    </Box>
  );
};

export default ActionButtons;